import { useEffect, useState } from "react";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PageHeader } from "@/components/common";
import { StatementForm } from "@/components/StatementForm";
import { useApi } from "@/lib/api";

export default function Statements() {
  const api = useApi();
  const [clients, setClients] = useState([]);
  const [cid, setCid] = useState("");
  const [accounts, setAccounts] = useState(null);
  useEffect(() => { api.get("/clients").then((r) => setClients(r.data.filter((c) => c.cuentas > 0))); }, [api]);
  useEffect(() => {
    if (cid) api.get("/accounts", { params: { client_id: cid } }).then((r) => setAccounts(r.data));
  }, [api, cid]);
  return (
    <>
      <PageHeader title="Estados de cuenta" subtitle="Genera el PDF mensual con logo y datos de e-Plata" />
      <div className="space-y-6 rounded-2xl border border-slate-200 bg-white p-6">
        <div className="max-w-md space-y-1.5">
          <Label className="text-xs text-slate-600">Cliente</Label>
          <Select value={cid} onValueChange={(v) => { setAccounts(null); setCid(v); }}>
            <SelectTrigger data-testid="statement-client-select"><SelectValue placeholder="Selecciona cliente con cuenta" /></SelectTrigger>
            <SelectContent>{clients.map((c) => <SelectItem key={c.id} value={c.id}>{c.nombre} · {c.rfc}</SelectItem>)}</SelectContent>
          </Select>
        </div>
        {accounts && <StatementForm key={cid} accounts={accounts} />}
      </div>
    </>
  );
}
